export default __webpack_public_path__ + "static/media/transactionMethod.db9da4da.svg";